import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn';  // 导入中文语言包

import Aside from '@/components/aside/index.vue'


const app = createApp(App)



// 配置全局错误处理
app.config.errorHandler = (err, vm, info) => {
  // 你可以在这里进行错误记录、发送到服务器等操作
  console.error('捕获到错误：', err);
  // 例如：忽略错误并不打印
  // 或者你可以选择发送错误信息到后端
};
app.component('Aside', Aside)
// 关闭所有开发模式警告
app.config.warnHandler = () => {};
app.use(ElementPlus,{ locale: zhCn })
app.use(store)
app.use(router)
app.mount('#app')
